import { useNavigate } from "react-router-dom";
import { ReactComponent as people } from "../../../../assets/images/people.svg";
import { SideSVG } from "../../../common";
import Logo from "../../Logo";
import LottieAnimation from "../../SuccessAnimation";
import { useEffect, useRef, useState } from "react";
import { Button } from "../../../common";
import { useSelector, useDispatch } from "react-redux";
import { useIndividualCompanyMutation } from "../../../../store/Company/companyApiSlice";

const RequestClaimSent = ({ company, status, step, onNext, onPrev }) => {
  const navigate = useNavigate();
  const { token, userInfo } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [individualCompany] = useIndividualCompanyMutation();
  const [count, setCount] = useState(0);

  let companyDataString = localStorage.getItem('createCompany');
  if (companyDataString === null) {
    companyDataString = localStorage.getItem('companyData');
  }

  const companyData = JSON.parse(JSON.stringify(companyDataString));

  
  return (
    <section className="relative py-20 lg:py-0 overflow-hidden">
      <div className="px-0 mx-auto">
        <div className="mx-auto relative">
          <Logo />
          <div className="flex flex-wrap -mx-4 xl:items-center">
            <div className="flex-flex1 w-full lg:w-1/2 xl:w-3/5 px-4 order-last lg:order-first">
              <div className="max-w-lg lg:py-20 mx-auto ">
                <LottieAnimation />
                <h3 className="font-heading text-h3 text-primary font-semibold mb-4 text-center">
                  Request Submitted!
                </h3>

                <p className="text-lg text-secondary mb-10 text-center">
                  Your claim request has been successfully sent. Monitor its
                  <br /> progress in your Dashboard.
                </p>
                <Button
                  classes="relative group block mx-auto mb-6 py-3 px-5 text-center text-sm font-semibold text-white bg-primary rounded-md overflow-hidden "
                  onClick={() => {
                    navigate("/dashboard/request");
                  }}
                >
                  <span className="flex items-center">
                    <span className="relative">Go to Dashboard</span>
                    <span className="pl-2">
                      <svg
                        width="15"
                        height="12"
                        viewBox="0 0 15 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.832031 6H14.1654M14.1654 6L9.16536 1M14.1654 6L9.16536 11"
                          stroke="#FFEEEA"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </span>
                </Button>
              </div>
            </div>
            <SideSVG SVG={people} positions="bottom-0  left-[-25%]" />

          </div>
        </div>
      </div>
    </section>
  );
};

export default RequestClaimSent;